// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change Login Password flow — scoped .pm-* */

.pm-page {
  width: 100%;
  min-height: 100%;
  /* Extra bottom space so primary CTA + eye toggles stay in scroll (profile column is viewport-locked) */
  padding: 35px 24px max(96px, calc(env(safe-area-inset-bottom, 0px) + 72px));
  max-width: 1200px;
  margin: 0 auto;
}

.pm-page *,
.pm-page *::before,
.pm-page *::after {
  box-sizing: border-box;
}

.pm-page__crumbs {
  margin-bottom: 18px;
}

.pm-page__crumbList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #8e939c;
  font-size: 15px;
  font-weight: 500;
}

.pm-page__crumbItem--active {
  color: #fff;
}

body.light_theme .pm-page__crumbItem--active {
  color: #101828;
}

.pm-page__crumbSep {
  color: #8e939c;
}

.pm-page__crumbLink {
  border: none;
  background: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.pm-page__title {
  margin: 0 0 28px;
  font-size: 36px;
  font-weight: 600;
  color: #fff;
  text-align: center;
}

body.light_theme .pm-page__title {
  color: #101828;
}

.pm-page__title--left {
  text-align: left;
}

/* Account Restrictions modal */
.pm-restrictOverlay {
  position: fixed;
  inset: 0;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  background-color: rgba(0, 0, 0, 0.50);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100000040;
}

body.light_theme .pm-restrictOverlay {
  background-color: rgb(255 255 255 / 20%);
}

.pm-restrictModal {
  width: 628px;
  max-width: 92vw;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  background: rgb(24 26 32 / 20%);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.50);
  padding: 24px;
  position: relative;
  text-align: center;
}

body.light_theme .pm-restrictModal {
  border: 1px solid #E1E1E1;
  background: rgb(255 255 255 / 20%);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
}

.pm-restrictModal__close {
  position: absolute;
  top: 12px;
  right: 14px;
  width: 34px;
  padding: 0px;
  height: 34px;
  border: none;
  background: transparent;
  font-size: 22px;
  cursor: pointer;
  border-radius: 8px;
  color: #8e939c;
}

body.light_theme .pm-restrictModal__close {
  color: #111827;
}

.pm-restrictModal__close:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

body.light_theme .pm-restrictModal__close:hover {
  background: rgba(17, 24, 39, 0.06);
  color: #111827;
}

.pm-restrictModal__art {
  margin: 8px auto 12px;
  max-width: 200px;
}

.pm-restrictModal__art img {
  width: 100%;
  height: auto;
  display: block;
}

.pm-restrictModal__title {
  margin: 15px 0 10px;
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
}

body.light_theme .pm-restrictModal__title {
  color: #101828;
}

.pm-restrictModal__text {
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 1.55;
  color: #84888C;
  font-weight: 500;
}

body.light_theme .pm-restrictModal__text {
  color: #6A7282;
}

.pm-restrictModal__actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.pm-restrictModal__cancel {
  height: 46px;
  border-radius: 999px;
  border: none;
  background: #2b3139;
  color: #eaecef;
  min-width: 160px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.pm-restrictModal__cancel:hover {
  background: #3a414b;
}

body.light_theme .pm-restrictModal__cancel {
  background: #e8eaed;
  color: #374151;
}

body.light_theme .pm-restrictModal__cancel:hover {
  background: #dce0e6;
}

.pm-restrictModal__confirm {
  flex: 1 1;
  height: 46px;
  border-radius: 999px;
  border: none;
  background: #d1aa67;
  color: #0c0d10;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease;
}

.pm-restrictModal__confirm:hover {
  background: #d1aa67;
}

body.light_theme .pm-restrictModal__confirm {
  background: #b89353;
  color: #fff;
}

body.light_theme .pm-restrictModal__confirm:hover {
  background: #1a1b1e;
}

/* Change password form */
.pm-form {
  max-width: 600px;
  margin: 60px auto;
  padding-bottom: 32px;
}

.pm-field {
  margin-bottom: 18px;
}

.pm-label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 7px;
}

body.light_theme .pm-label {
  color: #101828;
}

.pm-input {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: #181a20;
  padding: 0 14px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  outline: none;
}

body.light_theme .pm-input {
  border: 1px solid #e5e7ebb3;
  background: #F5F6F7;
  color: #101828;
}

.pm-input.is-error {
  border-color: #ef4444;
}

.pm-input.is-error:focus {
  box-shadow: none;
}

.pm-input::placeholder {
  color: #6b7280;
}

body.light_theme .pm-input::placeholder {
  color: #9ca3af;
}

.pm-inputWrap {
  position: relative;
  overflow: visible;
}

.pm-input.pm-input--withToggle {
  padding-right: 48px;
}

.pm-togglePw {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  line-height: 1;
  padding: 0;
  border-radius: 8px;
  flex-shrink: 0;
}

/* .pm-togglePw:hover {
  color: #111827;
  background: rgba(17, 24, 39, 0.06);
} */

/* Signup wizard rule list (same behavior as Signup “Set password”) — scoped to security password pages */
.pm-form .signup-wizard-rule-list,
.pm-resetNew .signup-wizard-rule-list {
  margin-top: 12px;
  transition: opacity 0.2s ease;
}

.pm-form .signup-wizard-rule-list--empty,
.pm-resetNew .signup-wizard-rule-list--empty {
  opacity: 0.38;
}

.pm-form .signup-wizard-rule-list:not(.signup-wizard-rule-list--empty),
.pm-resetNew .signup-wizard-rule-list:not(.signup-wizard-rule-list--empty) {
  opacity: 1;
}

.pm-form .signup-wizard-rule-row,
.pm-resetNew .signup-wizard-rule-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  margin-bottom: 6px;
  line-height: 1.35;
  opacity: 0.9;
}

.pm-form .signup-wizard-rule-list:not(.signup-wizard-rule-list--empty) .signup-wizard-rule-row,
.pm-resetNew .signup-wizard-rule-list:not(.signup-wizard-rule-list--empty) .signup-wizard-rule-row {
  opacity: 1;
}

.pm-form .signup-wizard-rule-row--ok i,
.pm-resetNew .signup-wizard-rule-row--ok i {
  color: #161616;
  margin-top: 1px;
  flex-shrink: 0;
}

.pm-form .signup-wizard-rule-row--bad i,
.pm-resetNew .signup-wizard-rule-row--bad i {
  color: #b91c1c;
  margin-top: 1px;
  flex-shrink: 0;
}

.pm-form .signup-wizard-rule-row--pending,
.pm-resetNew .signup-wizard-rule-row--pending {
  opacity: 0.55;
}

.pm-form .signup-wizard-rule-row--pending i,
.pm-resetNew .signup-wizard-rule-row--pending i {
  color: #9ca3af;
  margin-top: 1px;
  flex-shrink: 0;
}

.pm-form .signup-wizard-rule-row--pending span,
.pm-resetNew .signup-wizard-rule-row--pending span {
  color: #6b7280;
}

.pm-form .signup-wizard-rule-list--empty .signup-wizard-rule-row--idle,
.pm-resetNew .signup-wizard-rule-list--empty .signup-wizard-rule-row--idle {
  opacity: 0.85;
}

.pm-form .signup-wizard-rule-row--idle i,
.pm-resetNew .signup-wizard-rule-row--idle i {
  color: #9ca3af;
  margin-top: 1px;
  flex-shrink: 0;
}

body.light_theme .pm-form .signup-wizard-rule-row,
body.light_theme .pm-resetNew .signup-wizard-rule-row {
  color: #374151;
}

.pm-form .signup-wizard-rule-row span,
.pm-resetNew .signup-wizard-rule-row span {
  color: #ffffff;
}

body.light_theme .pm-form .signup-wizard-rule-row span,
body.light_theme .pm-resetNew .signup-wizard-rule-row span {
  color: #4b5563;
}

.pm-rules {
  margin: 16px 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 11px;
}

.pm-rule {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
}

.pm-ruleIcon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  /* background: #c3c5c7; */
  color: #fff;
  display: inline-flex;
  align-items: center;
  opacity: 0.5;
  justify-content: center;
  font-size: 10px;
  flex-shrink: 0;
  margin-top: 1px;
}

.pm-ruleIcon.is-ok {
  background: #00a870;
}

.pm-confirmBtn {
  width: 100%;
  height: 48px;
  margin-top: 10px;
  margin-bottom: 8px;
  border: none;
  border-radius: 999px;
  background: #303236;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
}

.pm-confirmBtn.is-enabled {
  background: #fcd535;
  color: #0c0d10;
  cursor: pointer;
}

body.light_theme .pm-confirmBtn.is-enabled {
  background: #2d2e32;
  color: #fff;
}

.pm-inlineError {
  margin-top: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #ef4444;
}

.pm-forgot {
  display: block;
  width: 100%;
  margin-top: 16px;
  border: none;
  background: transparent;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

body.light_theme .pm-forgot {
  color: #101828;
}

/* Reset password — tabs + input */
.pm-reset {
  max-width: 520px;
  margin: 60px auto;
}

.pm-reset__title {
  margin: 0 0 22px;
  font-size: 36px;
  font-weight: 600;
  color: #ffffff;
  text-align: left;
}

body.light_theme .pm-reset__title {
  color: #101828;
}

.pm-tabs {
  display: flex;
  gap: 16px;
  margin-bottom: 18px;
  border-bottom: none;
}

.pm-tab {
  border: none;
  background: transparent;
  padding: 0 0 8px;
  font-size: 15px;
  font-weight: 600;
  color: #9ca3af;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
}

.pm-tab.is-active {
  color: #101828;
  border-bottom-color: #101828;
}

.pm-reset .pm-field {
  margin-bottom: 0px;
}

.pm-phoneRow {
  display: flex;
  align-items: stretch;
  border-radius: 10px;
  border: 1px solid #ebebeb;
  background: #F5F6F7;
  overflow: hidden;
  height: 48px;
}

.pm-phonePrefix {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  border-right: 1px solid #e5e7eb;
  font-size: 13px;
  font-weight: 600;
  color: #101828;
  background: #eef0f2;
  cursor: pointer;
  border: none;
}

.pm-phoneInput {
  flex: 1 1;
  border: none;
  background: transparent;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 600;
  outline: none;
}

/* Reset flow: working country selector + number (AuthPhoneField) */
.pm-reset .pm-phoneWrap {
  width: 100%;
}

.pm-reset .pm-phoneWrap .auth-phone-field {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 48px;
  height: 48px;
  border-radius: 10px;
  background: #f5f6f7;
  border: 1px solid #ebebeb;
  box-sizing: border-box;
  overflow: visible;
}

.pm-reset .pm-phoneWrap .auth-phone-field.auth-phone-field--unified:focus-within {
  border-color: #c5c8cc;
  outline: none;
}

.pm-reset .pm-phoneWrap .auth-phone-field__country {
  flex: 0 0 auto;
  min-width: 0;
  max-width: 46%;
  display: flex;
  align-items: center;
}

.pm-reset .pm-phoneWrap .auth-phone-field__divider {
  align-self: stretch;
  width: 1px;
  min-width: 1px;
  background: #e5e7eb;
  margin: 8px 0;
  flex-shrink: 0;
}

.pm-reset .pm-phoneWrap .auth-phone-field__number {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: stretch;
}

.pm-reset .pm-phoneWrap .auth-phone-field__input.input_filed {
  flex: 1 1;
  width: 100%;
  min-width: 0;
  height: 100%;
  min-height: 0;
  margin: 0;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 600;
  color: #101828;
}

.pm-reset .pm-phoneWrap .auth-phone-field__input.input_filed:focus {
  outline: none;
}

.pm-reset .pm-phoneWrap .auth-phone-country-inner {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.pm-reset .pm-phoneWrap .auth-phone-country-flag {
  font-size: 1.05rem;
  line-height: 1;
}

.pm-reset .pm-phoneWrap .auth-phone-country-code {
  font-weight: 600;
  font-size: 13px;
  letter-spacing: -0.01em;
  color: #101828;
}

.pm-reset .pm-phoneWrap .auth-phone-country__control {
  min-height: 48px !important;
  cursor: pointer;
}

.pm-nextBtn {
  width: 100%;
  height: 48px;
  margin-top: 28px;
  border: none;
  border-radius: 999px;
  background: #2d2e32;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.pm-nextBtn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Full-page verify (forgot flow) */
.pm-verifyPage {
  max-width: 480px;
  margin: 0 auto;
  text-align: center;
}

.pm-verifyPage__title {
  margin: 0 0 10px;
  font-size: 24px;
  font-weight: 700;
  color: #101828;
}

.pm-verifyPage__sub {
  margin: 0 0 22px;
  font-size: 14px;
  color: #84888c;
  line-height: 1.45;
}

.pm-verifyPage__link {
  margin-top: 16px;
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 700;
  color: #101828;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

/* Reset new password */
.pm-resetNew {
  max-width: 600px;
  margin: 60px auto;
  padding-bottom: max(48px, env(safe-area-inset-bottom, 0px));
}

.pm-resetNew__title {
  margin: 0 0 24px;
  font-size: 36px;
  font-weight: 600;
  color: #101828;
  text-align: left;
}

.pm-resetBtn {
  width: 100%;
  height: 48px;
  margin-top: 12px;
  margin-bottom: 8px;
  border: none;
  border-radius: 999px;
  background: #303236;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: not-allowed;
  flex-shrink: 0;
}

.pm-resetBtn.is-enabled {
  background: #2d2e32;
  cursor: pointer;
}

.pm-verifyFooter {
  margin-top: 4px;
  text-align: center;
}

@media (max-width: 991px) {

  .pm-reset__title {
    font-size: 24px;
  }

  .pm-page__title {
    font-size: 24px;
  }

  .pm-reset {
    margin: 30px auto;
  }

  .pm-resetNew__title {
    margin: 0 0 20px;
    font-size: 24px;
  }

  .pm-resetNew {
    margin: 30px auto;
    padding-bottom: max(0px, env(safe-area-inset-bottom, 0px));
  }

  .pm-page {
    padding: 35px 24px max(24px, calc(env(safe-area-inset-bottom, 0px) + 32px));
  }

  .ca-reason__heading {
    font-size: 22px;
  }

  .ca-reason__option {
    padding: 20px;
  }

  .ca-assets__lead {
    font-size: 24px;
  }

  section.ca-assets {
    margin: 30px auto;
  }

}

@media (max-width: 767px) {

  .pm-restrictOverlay {
    align-items: end;
  }

  .pm-restrictModal__art {
    max-width: 150px;
  }

  .ca-modal-overlay {
    align-items: end;
    padding: 0px;
  }

  .ca-modal {
    max-width: 100%;
    border-radius: 18px 18px 0px 0px;
  }

  .ca-modal__title {
    padding: 0 20px;
    font-size: 22px;
  }

  .ca-evm-overlay {
    align-items: end;
    padding: 0px;
  }

  .ca-evm {
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
  }

  .ca-evm__submit {
    height: 42px;
    font-size: 14px;
  }

  .ca-assets__lead {
    font-size: 20px;
  }

  .ca-reason__heading {
    font-size: 20px;
  }

  .pm-page__title {
    font-size: 22px;
  }

  .pm-restrictModal {
    max-width: 100%;
    border-radius: 16px 16px 0px 0px;
    width: 100%;
  }

  .pm-restrictModal__title {
    font-size: 20px;
  }

  .pm-form {
    margin: 30px auto;
    padding-bottom: 10px;
  }

  .pm-restrictModal__confirm {
    height: 42px;
  }

  .pm-restrictModal__cancel {
    height: 42px;
  }

}

/*
 * Choose Verification Method — above Authenticator (.withdraw_sec_overlay z-index 100000020).
 * \`withdrawal.css\` loads AFTER this file and sets \`.withdraw_confirm_overlay { z-index: 99999999 }\`
 * with equal specificity, which was overwriting a single-class stacked rule. Compound selector wins.
 */
.withdraw_confirm_overlay.pm-choose-method-overlay-stacked {
  z-index: 100000050;
}

/* Choose Verification Method — Change Login Password (aligned with reference popup) */
.pm-choose-method-modal {
  min-height: auto;
}

.pm-choose-method-modal__topbar {
  justify-content: flex-end;
  margin-bottom: 4px;
}

.pm-choose-method-modal__topbarSpacer {
  width: 36px;
  flex-shrink: 0;
}

.pm-choose-method-modal__title {
  margin-top: 0;
}

.pm-choose-method-modal__subtitle {
  margin-bottom: 18px;
}

.pm-choose-method-modal__list.emailphone_outerbl {
  margin-top: 8px;
}

.pm-choose-method-item {
  justify-content: flex-start;
  text-align: left;
  margin-top: 12px;
}

.pm-choose-method-modal__list .pm-choose-method-item:first-child {
  margin-top: 0;
}

.pm-choose-method-item__text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.pm-choose-method-item__title {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.3;
}

body.light_theme .pm-choose-method-item__title {
  color: #111827;
}

.pm-choose-method-item__desc {
  font-size: 14px;
  font-weight: 400;
  color: #84888C;
  line-height: 1.35;
}

body.light_theme .pm-choose-method-item__desc {
  color: #6a7282;
}

.pm-choose-method-item__chevron {
  font-size: 22px;
  color: #84888C;
  flex-shrink: 0;
  margin-left: 6px;
}

body.light_theme .pm-choose-method-item__chevron {
  color: #9ca3af;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TwofactorPage/changeLoginPassword.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;EACE,WAAW;EACX,gBAAgB;EAChB,uGAAuG;EACvG,2EAA2E;EAC3E,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,QAAQ;EACR,0BAA0B;EAC1B,kCAAkC;EAClC,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,mBAAmB;EACnB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;GAGG;;AAEH,yGAAyG;AACzG;;EAEE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA,mEAAmE;AACnE;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2DAA2D;AAC7D;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,0DAA0D;EAC5D;;EAEA;IACE,2EAA2E;EAC7E;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;AAEA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;AAEF;;AAEA;;;;EAIE;AACF;EACE,kBAAkB;AACpB;;AAEA,sFAAsF;AACtF;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Change Login Password flow — scoped .pm-* */\n\n.pm-page {\n  width: 100%;\n  min-height: 100%;\n  /* Extra bottom space so primary CTA + eye toggles stay in scroll (profile column is viewport-locked) */\n  padding: 35px 24px max(96px, calc(env(safe-area-inset-bottom, 0px) + 72px));\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.pm-page *,\n.pm-page *::before,\n.pm-page *::after {\n  box-sizing: border-box;\n}\n\n.pm-page__crumbs {\n  margin-bottom: 18px;\n}\n\n.pm-page__crumbList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #8e939c;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.pm-page__crumbItem--active {\n  color: #fff;\n}\n\nbody.light_theme .pm-page__crumbItem--active {\n  color: #101828;\n}\n\n.pm-page__crumbSep {\n  color: #8e939c;\n}\n\n.pm-page__crumbLink {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.pm-page__title {\n  margin: 0 0 28px;\n  font-size: 36px;\n  font-weight: 600;\n  color: #fff;\n  text-align: center;\n}\n\nbody.light_theme .pm-page__title {\n  color: #101828;\n}\n\n.pm-page__title--left {\n  text-align: left;\n}\n\n/* Account Restrictions modal */\n.pm-restrictOverlay {\n  position: fixed;\n  inset: 0;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  background-color: rgba(0, 0, 0, 0.50);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100000040;\n}\n\nbody.light_theme .pm-restrictOverlay {\n  background-color: rgb(255 255 255 / 20%);\n}\n\n.pm-restrictModal {\n  width: 628px;\n  max-width: 92vw;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  background: rgb(24 26 32 / 20%);\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 28px 60px rgba(0, 0, 0, 0.50);\n  padding: 24px;\n  position: relative;\n  text-align: center;\n}\n\nbody.light_theme .pm-restrictModal {\n  border: 1px solid #E1E1E1;\n  background: rgb(255 255 255 / 20%);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);\n}\n\n.pm-restrictModal__close {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  width: 34px;\n  padding: 0px;\n  height: 34px;\n  border: none;\n  background: transparent;\n  font-size: 22px;\n  cursor: pointer;\n  border-radius: 8px;\n  color: #8e939c;\n}\n\nbody.light_theme .pm-restrictModal__close {\n  color: #111827;\n}\n\n.pm-restrictModal__close:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\nbody.light_theme .pm-restrictModal__close:hover {\n  background: rgba(17, 24, 39, 0.06);\n  color: #111827;\n}\n\n.pm-restrictModal__art {\n  margin: 8px auto 12px;\n  max-width: 200px;\n}\n\n.pm-restrictModal__art img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.pm-restrictModal__title {\n  margin: 15px 0 10px;\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\nbody.light_theme .pm-restrictModal__title {\n  color: #101828;\n}\n\n.pm-restrictModal__text {\n  margin: 0 0 20px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #84888C;\n  font-weight: 500;\n}\n\nbody.light_theme .pm-restrictModal__text {\n  color: #6A7282;\n}\n\n.pm-restrictModal__actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.pm-restrictModal__cancel {\n  height: 46px;\n  border-radius: 999px;\n  border: none;\n  background: #2b3139;\n  color: #eaecef;\n  min-width: 160px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.pm-restrictModal__cancel:hover {\n  background: #3a414b;\n}\n\nbody.light_theme .pm-restrictModal__cancel {\n  background: #e8eaed;\n  color: #374151;\n}\n\nbody.light_theme .pm-restrictModal__cancel:hover {\n  background: #dce0e6;\n}\n\n.pm-restrictModal__confirm {\n  flex: 1;\n  height: 46px;\n  border-radius: 999px;\n  border: none;\n  background: #d1aa67;\n  color: #0c0d10;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.pm-restrictModal__confirm:hover {\n  background: #d1aa67;\n}\n\nbody.light_theme .pm-restrictModal__confirm {\n  background: #b89353;\n  color: #fff;\n}\n\nbody.light_theme .pm-restrictModal__confirm:hover {\n  background: #1a1b1e;\n}\n\n/* Change password form */\n.pm-form {\n  max-width: 600px;\n  margin: 60px auto;\n  padding-bottom: 32px;\n}\n\n.pm-field {\n  margin-bottom: 18px;\n}\n\n.pm-label {\n  display: block;\n  font-size: 16px;\n  font-weight: 500;\n  color: #fff;\n  margin-bottom: 7px;\n}\n\nbody.light_theme .pm-label {\n  color: #101828;\n}\n\n.pm-input {\n  width: 100%;\n  height: 48px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: #181a20;\n  padding: 0 14px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  outline: none;\n}\n\nbody.light_theme .pm-input {\n  border: 1px solid #e5e7ebb3;\n  background: #F5F6F7;\n  color: #101828;\n}\n\n.pm-input.is-error {\n  border-color: #ef4444;\n}\n\n.pm-input.is-error:focus {\n  box-shadow: none;\n}\n\n.pm-input::placeholder {\n  color: #6b7280;\n}\n\nbody.light_theme .pm-input::placeholder {\n  color: #9ca3af;\n}\n\n.pm-inputWrap {\n  position: relative;\n  overflow: visible;\n}\n\n.pm-input.pm-input--withToggle {\n  padding-right: 48px;\n}\n\n.pm-togglePw {\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  line-height: 1;\n  padding: 0;\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n/* .pm-togglePw:hover {\n  color: #111827;\n  background: rgba(17, 24, 39, 0.06);\n} */\n\n/* Signup wizard rule list (same behavior as Signup “Set password”) — scoped to security password pages */\n.pm-form .signup-wizard-rule-list,\n.pm-resetNew .signup-wizard-rule-list {\n  margin-top: 12px;\n  transition: opacity 0.2s ease;\n}\n\n.pm-form .signup-wizard-rule-list--empty,\n.pm-resetNew .signup-wizard-rule-list--empty {\n  opacity: 0.38;\n}\n\n.pm-form .signup-wizard-rule-list:not(.signup-wizard-rule-list--empty),\n.pm-resetNew .signup-wizard-rule-list:not(.signup-wizard-rule-list--empty) {\n  opacity: 1;\n}\n\n.pm-form .signup-wizard-rule-row,\n.pm-resetNew .signup-wizard-rule-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  font-size: 12px;\n  margin-bottom: 6px;\n  line-height: 1.35;\n  opacity: 0.9;\n}\n\n.pm-form .signup-wizard-rule-list:not(.signup-wizard-rule-list--empty) .signup-wizard-rule-row,\n.pm-resetNew .signup-wizard-rule-list:not(.signup-wizard-rule-list--empty) .signup-wizard-rule-row {\n  opacity: 1;\n}\n\n.pm-form .signup-wizard-rule-row--ok i,\n.pm-resetNew .signup-wizard-rule-row--ok i {\n  color: #161616;\n  margin-top: 1px;\n  flex-shrink: 0;\n}\n\n.pm-form .signup-wizard-rule-row--bad i,\n.pm-resetNew .signup-wizard-rule-row--bad i {\n  color: #b91c1c;\n  margin-top: 1px;\n  flex-shrink: 0;\n}\n\n.pm-form .signup-wizard-rule-row--pending,\n.pm-resetNew .signup-wizard-rule-row--pending {\n  opacity: 0.55;\n}\n\n.pm-form .signup-wizard-rule-row--pending i,\n.pm-resetNew .signup-wizard-rule-row--pending i {\n  color: #9ca3af;\n  margin-top: 1px;\n  flex-shrink: 0;\n}\n\n.pm-form .signup-wizard-rule-row--pending span,\n.pm-resetNew .signup-wizard-rule-row--pending span {\n  color: #6b7280;\n}\n\n.pm-form .signup-wizard-rule-list--empty .signup-wizard-rule-row--idle,\n.pm-resetNew .signup-wizard-rule-list--empty .signup-wizard-rule-row--idle {\n  opacity: 0.85;\n}\n\n.pm-form .signup-wizard-rule-row--idle i,\n.pm-resetNew .signup-wizard-rule-row--idle i {\n  color: #9ca3af;\n  margin-top: 1px;\n  flex-shrink: 0;\n}\n\nbody.light_theme .pm-form .signup-wizard-rule-row,\nbody.light_theme .pm-resetNew .signup-wizard-rule-row {\n  color: #374151;\n}\n\n.pm-form .signup-wizard-rule-row span,\n.pm-resetNew .signup-wizard-rule-row span {\n  color: #ffffff;\n}\n\nbody.light_theme .pm-form .signup-wizard-rule-row span,\nbody.light_theme .pm-resetNew .signup-wizard-rule-row span {\n  color: #4b5563;\n}\n\n.pm-rules {\n  margin: 16px 0 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 11px;\n}\n\n.pm-rule {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 14px;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.pm-ruleIcon {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  /* background: #c3c5c7; */\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  opacity: 0.5;\n  justify-content: center;\n  font-size: 10px;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.pm-ruleIcon.is-ok {\n  background: #00a870;\n}\n\n.pm-confirmBtn {\n  width: 100%;\n  height: 48px;\n  margin-top: 10px;\n  margin-bottom: 8px;\n  border: none;\n  border-radius: 999px;\n  background: #303236;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.pm-confirmBtn.is-enabled {\n  background: #fcd535;\n  color: #0c0d10;\n  cursor: pointer;\n}\n\nbody.light_theme .pm-confirmBtn.is-enabled {\n  background: #2d2e32;\n  color: #fff;\n}\n\n.pm-inlineError {\n  margin-top: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #ef4444;\n}\n\n.pm-forgot {\n  display: block;\n  width: 100%;\n  margin-top: 16px;\n  border: none;\n  background: transparent;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  cursor: pointer;\n}\n\nbody.light_theme .pm-forgot {\n  color: #101828;\n}\n\n/* Reset password — tabs + input */\n.pm-reset {\n  max-width: 520px;\n  margin: 60px auto;\n}\n\n.pm-reset__title {\n  margin: 0 0 22px;\n  font-size: 36px;\n  font-weight: 600;\n  color: #ffffff;\n  text-align: left;\n}\n\nbody.light_theme .pm-reset__title {\n  color: #101828;\n}\n\n.pm-tabs {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 18px;\n  border-bottom: none;\n}\n\n.pm-tab {\n  border: none;\n  background: transparent;\n  padding: 0 0 8px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #9ca3af;\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -2px;\n}\n\n.pm-tab.is-active {\n  color: #101828;\n  border-bottom-color: #101828;\n}\n\n.pm-reset .pm-field {\n  margin-bottom: 0px;\n}\n\n.pm-phoneRow {\n  display: flex;\n  align-items: stretch;\n  border-radius: 10px;\n  border: 1px solid #ebebeb;\n  background: #F5F6F7;\n  overflow: hidden;\n  height: 48px;\n}\n\n.pm-phonePrefix {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 10px;\n  border-right: 1px solid #e5e7eb;\n  font-size: 13px;\n  font-weight: 600;\n  color: #101828;\n  background: #eef0f2;\n  cursor: pointer;\n  border: none;\n}\n\n.pm-phoneInput {\n  flex: 1;\n  border: none;\n  background: transparent;\n  padding: 0 12px;\n  font-size: 13px;\n  font-weight: 600;\n  outline: none;\n}\n\n/* Reset flow: working country selector + number (AuthPhoneField) */\n.pm-reset .pm-phoneWrap {\n  width: 100%;\n}\n\n.pm-reset .pm-phoneWrap .auth-phone-field {\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  min-height: 48px;\n  height: 48px;\n  border-radius: 10px;\n  background: #f5f6f7;\n  border: 1px solid #ebebeb;\n  box-sizing: border-box;\n  overflow: visible;\n}\n\n.pm-reset .pm-phoneWrap .auth-phone-field.auth-phone-field--unified:focus-within {\n  border-color: #c5c8cc;\n  outline: none;\n}\n\n.pm-reset .pm-phoneWrap .auth-phone-field__country {\n  flex: 0 0 auto;\n  min-width: 0;\n  max-width: 46%;\n  display: flex;\n  align-items: center;\n}\n\n.pm-reset .pm-phoneWrap .auth-phone-field__divider {\n  align-self: stretch;\n  width: 1px;\n  min-width: 1px;\n  background: #e5e7eb;\n  margin: 8px 0;\n  flex-shrink: 0;\n}\n\n.pm-reset .pm-phoneWrap .auth-phone-field__number {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  align-items: stretch;\n}\n\n.pm-reset .pm-phoneWrap .auth-phone-field__input.input_filed {\n  flex: 1;\n  width: 100%;\n  min-width: 0;\n  height: 100%;\n  min-height: 0;\n  margin: 0;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  padding: 0 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #101828;\n}\n\n.pm-reset .pm-phoneWrap .auth-phone-field__input.input_filed:focus {\n  outline: none;\n}\n\n.pm-reset .pm-phoneWrap .auth-phone-country-inner {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.pm-reset .pm-phoneWrap .auth-phone-country-flag {\n  font-size: 1.05rem;\n  line-height: 1;\n}\n\n.pm-reset .pm-phoneWrap .auth-phone-country-code {\n  font-weight: 600;\n  font-size: 13px;\n  letter-spacing: -0.01em;\n  color: #101828;\n}\n\n.pm-reset .pm-phoneWrap .auth-phone-country__control {\n  min-height: 48px !important;\n  cursor: pointer;\n}\n\n.pm-nextBtn {\n  width: 100%;\n  height: 48px;\n  margin-top: 28px;\n  border: none;\n  border-radius: 999px;\n  background: #2d2e32;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.pm-nextBtn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Full-page verify (forgot flow) */\n.pm-verifyPage {\n  max-width: 480px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.pm-verifyPage__title {\n  margin: 0 0 10px;\n  font-size: 24px;\n  font-weight: 700;\n  color: #101828;\n}\n\n.pm-verifyPage__sub {\n  margin: 0 0 22px;\n  font-size: 14px;\n  color: #84888c;\n  line-height: 1.45;\n}\n\n.pm-verifyPage__link {\n  margin-top: 16px;\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  font-weight: 700;\n  color: #101828;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  cursor: pointer;\n}\n\n/* Reset new password */\n.pm-resetNew {\n  max-width: 600px;\n  margin: 60px auto;\n  padding-bottom: max(48px, env(safe-area-inset-bottom, 0px));\n}\n\n.pm-resetNew__title {\n  margin: 0 0 24px;\n  font-size: 36px;\n  font-weight: 600;\n  color: #101828;\n  text-align: left;\n}\n\n.pm-resetBtn {\n  width: 100%;\n  height: 48px;\n  margin-top: 12px;\n  margin-bottom: 8px;\n  border: none;\n  border-radius: 999px;\n  background: #303236;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: not-allowed;\n  flex-shrink: 0;\n}\n\n.pm-resetBtn.is-enabled {\n  background: #2d2e32;\n  cursor: pointer;\n}\n\n.pm-verifyFooter {\n  margin-top: 4px;\n  text-align: center;\n}\n\n@media (max-width: 991px) {\n\n  .pm-reset__title {\n    font-size: 24px;\n  }\n\n  .pm-page__title {\n    font-size: 24px;\n  }\n\n  .pm-reset {\n    margin: 30px auto;\n  }\n\n  .pm-resetNew__title {\n    margin: 0 0 20px;\n    font-size: 24px;\n  }\n\n  .pm-resetNew {\n    margin: 30px auto;\n    padding-bottom: max(0px, env(safe-area-inset-bottom, 0px));\n  }\n\n  .pm-page {\n    padding: 35px 24px max(24px, calc(env(safe-area-inset-bottom, 0px) + 32px));\n  }\n\n  .ca-reason__heading {\n    font-size: 22px;\n  }\n\n  .ca-reason__option {\n    padding: 20px;\n  }\n\n  .ca-assets__lead {\n    font-size: 24px;\n  }\n\n  section.ca-assets {\n    margin: 30px auto;\n  }\n\n}\n\n@media (max-width: 767px) {\n\n  .pm-restrictOverlay {\n    align-items: end;\n  }\n\n  .pm-restrictModal__art {\n    max-width: 150px;\n  }\n\n  .ca-modal-overlay {\n    align-items: end;\n    padding: 0px;\n  }\n\n  .ca-modal {\n    max-width: 100%;\n    border-radius: 18px 18px 0px 0px;\n  }\n\n  .ca-modal__title {\n    padding: 0 20px;\n    font-size: 22px;\n  }\n\n  .ca-evm-overlay {\n    align-items: end;\n    padding: 0px;\n  }\n\n  .ca-evm {\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n  }\n\n  .ca-evm__submit {\n    height: 42px;\n    font-size: 14px;\n  }\n\n  .ca-assets__lead {\n    font-size: 20px;\n  }\n\n  .ca-reason__heading {\n    font-size: 20px;\n  }\n\n  .pm-page__title {\n    font-size: 22px;\n  }\n\n  .pm-restrictModal {\n    max-width: 100%;\n    border-radius: 16px 16px 0px 0px;\n    width: 100%;\n  }\n\n  .pm-restrictModal__title {\n    font-size: 20px;\n  }\n\n  .pm-form {\n    margin: 30px auto;\n    padding-bottom: 10px;\n  }\n\n  .pm-restrictModal__confirm {\n    height: 42px;\n  }\n\n  .pm-restrictModal__cancel {\n    height: 42px;\n  }\n\n}\n\n/*\n * Choose Verification Method — above Authenticator (.withdraw_sec_overlay z-index 100000020).\n * `withdrawal.css` loads AFTER this file and sets `.withdraw_confirm_overlay { z-index: 99999999 }`\n * with equal specificity, which was overwriting a single-class stacked rule. Compound selector wins.\n */\n.withdraw_confirm_overlay.pm-choose-method-overlay-stacked {\n  z-index: 100000050;\n}\n\n/* Choose Verification Method — Change Login Password (aligned with reference popup) */\n.pm-choose-method-modal {\n  min-height: auto;\n}\n\n.pm-choose-method-modal__topbar {\n  justify-content: flex-end;\n  margin-bottom: 4px;\n}\n\n.pm-choose-method-modal__topbarSpacer {\n  width: 36px;\n  flex-shrink: 0;\n}\n\n.pm-choose-method-modal__title {\n  margin-top: 0;\n}\n\n.pm-choose-method-modal__subtitle {\n  margin-bottom: 18px;\n}\n\n.pm-choose-method-modal__list.emailphone_outerbl {\n  margin-top: 8px;\n}\n\n.pm-choose-method-item {\n  justify-content: flex-start;\n  text-align: left;\n  margin-top: 12px;\n}\n\n.pm-choose-method-modal__list .pm-choose-method-item:first-child {\n  margin-top: 0;\n}\n\n.pm-choose-method-item__text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.pm-choose-method-item__title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  line-height: 1.3;\n}\n\nbody.light_theme .pm-choose-method-item__title {\n  color: #111827;\n}\n\n.pm-choose-method-item__desc {\n  font-size: 14px;\n  font-weight: 400;\n  color: #84888C;\n  line-height: 1.35;\n}\n\nbody.light_theme .pm-choose-method-item__desc {\n  color: #6a7282;\n}\n\n.pm-choose-method-item__chevron {\n  font-size: 22px;\n  color: #84888C;\n  flex-shrink: 0;\n  margin-left: 6px;\n}\n\nbody.light_theme .pm-choose-method-item__chevron {\n  color: #9ca3af;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
